import e from"react";import r from"../LabelText/LabelText.js";var t=function(t){var a=t.label;return e.createElement(r,null,a)};export{t as default};
//# sourceMappingURL=Label.js.map
